import { useSelector } from 'react-redux';
import { Trackable } from '@dpdgroupuk/react-event-tracker';

import { ANALYTICS } from '../../constants';
import ContentLayout from '../../components/ContentLayout/ContentLayout';
import configSlice from '../../redux/configSlice';
import * as faqsPageData from '../../assets/json/faqs-data.json';
import { filterSameDayFaqSection } from './helpers';

const Faqs = () => {
  const { title, components } = faqsPageData;
  const { sameday } = useSelector(configSlice.selectors.getFeatureConfig);

  return (
    <Trackable loadId={ANALYTICS.FAQS.INTERFACE_ID}>
      <ContentLayout
        title={title}
        components={filterSameDayFaqSection(components, sameday)}
        styles={{
          container: {
            maxWidth: 672,
            margin: '0 auto',
            boxSizing: 'content-box',
            px: { xs: 2, md: 8 },
            py: { xs: 8, md: 4 },
          },
          title: { mb: 3 },
        }}
      />
    </Trackable>
  );
};

export default Faqs;
